import clsx from 'clsx'
const classNames = clsx

export { clsx, classNames }
